<template>
  <div class="app" :class="{'mosaic-page': currentRoute == '/realtime', 'normal-page': currentRoute != '/realtime'}">
    <div v-if="!loading">
      <MainHeader v-if="isLogged && currentRoute !== '/' && !isPublicParkingPayment" />
      <MainSidebar :showOptionsAdm="showOptionsAdm" v-if="isLogged && currentRoute !== '/' && !isPublicParkingPayment" />
      <div class="main-content d-flex flex-column transition overflow-hidden" :class="{'center-main-content': !isLogged, 'justify-content-start validate-home-page': currentRoute === '/'}">
        <router-view />
        <MainFooter v-if="isLogged && currentRoute !== '/' && !isPublicParkingPayment" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, watchEffect } from "vue";
import { mapGetters, mapActions } from 'vuex';
import { useRoute } from 'vue-router';
import stateStore from "./utils/store";

import { getAuthenticatedUser } from '@/services/authService';

import MainHeader from "./components/Layouts/MainHeader.vue";
import MainSidebar from "./components/Layouts/MainSidebar.vue";
import MainFooter from "./components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "App",
  data () {
    return {
      isLogged: false,
      loading: true,
      showOptionsAdm: false
    }
  },
  components: {
    MainHeader,
    MainSidebar,
    MainFooter,
  },  
  methods: {
    ...mapActions([
      "reloadData",
      "setConfiguration"
    ]),
    isPublicRoute() {
      return window.location.pathname.replace(/\/$/, '') === "/parking/payment";
    }
  },
  computed:{
    ...mapGetters([
      'getConfigurations'
    ]),
  },
  watch: {
    getConfigurations(newValue){

      if(newValue.adm == true && newValue.installation == null){

        this.showOptionsAdm = true;

      } else if(newValue.adm == false && newValue.installation != null){
        if(window.location.pathname === "/installation" || window.location.pathname === "/payment" || window.location.pathname.match(/^\/installation\/\d+$/)){
          window.location.href = "/realtime";
        }
      }
    }
  },
  async created() {
    if(this.isPublicRoute()){
      this.isLogged = false;
      this.loading = false;
      return;
    }

    const authenticatedUser = await getAuthenticatedUser();

    if(authenticatedUser){
      this.reloadData(authenticatedUser);
      if(window.location.pathname === "/" || window.location.pathname === "/login" || window.location.pathname === "/register" || window.location.pathname === "/forgot-password" || window.location.pathname === "/send-email-forgot-password" || window.location.pathname === "/terms"){
        window.location.href = "/realtime";
        return;
      }
      this.isLogged = true;
      this.loading = false;
    } else {
      this.isLogged = false;
      if(window.location.pathname !== "/" && window.location.pathname !== "/login" && window.location.pathname !== "/register" && window.location.pathname !== "/forgot-password" && window.location.pathname !== "/send-email-forgot-password" && window.location.pathname !== "/terms" && !this.isPublicRoute()){
        window.location.href = "/login";
      }
      this.loading = false;
    }
  },
  mounted() {
    document.body.classList.add("bg-body-secondary");
    if(!this.isPublicRoute()){
      this.setConfiguration();
    }
  },
  setup() {
    const route = useRoute();
    const stateStoreInstance = stateStore;
    
    const currentRoute = computed(() => route.path);
    const isPublicParkingPayment = computed(() => route.path === '/parking/payment');

    watchEffect(() => {
      if (stateStoreInstance.open) {
        document.body.classList.remove("sidebar-show");
        document.body.classList.add("sidebar-hide");
      } else {
        document.body.classList.remove("sidebar-hide");
        document.body.classList.add("sidebar-show");
      }
    });

    return {
      currentRoute,
      isPublicParkingPayment
    };
  },
});
</script>
<style scoped>
.validate-home-page{
  padding: unset !important;
}

@media (max-width: 767px) {
  .main-content:not(.validate-home-page) {
    padding-top: 0 !important;
    padding-bottom: calc(64px + env(safe-area-inset-bottom));
  }
}
</style>
